<template>
  <div>
    <!-- View Mode -->
    <div v-if="!editing">
      <!-- Chips -->
      <div v-if="modelValue.length" style="max-height: 120px; overflow-y: auto">
        <span
          v-for="item in modelValue"
          :key="item[trackBy]"
          class="badge badge-primary mr-2 mb-2"
          style="padding: 8px 12px; font-size: 13px"
        >
          <slot name="chip" :item="item">{{ item[label] }}</slot>
        </span>
      </div>
      <div v-else>
        <div class="badge-theme p-2 mb-1 rounded d-inline-block">
          {{ emptyText }}
        </div>
      </div>

      <!-- Add/Edit Button -->
      <button
        v-if="!disabled"
        type="button"
        class="btn btn-sm btn-black mt-1"
        :disabled="loading"
        @click="editing = true"
      >
        <i v-if="loading" class="fas fa-spin fa-circle-notch mr-1"></i>
        <i
          v-else
          :class="modelValue.length ? 'fas fa-edit mr-1' : 'fas fa-plus mr-1'"
        ></i>
        {{ modelValue.length ? "Edit" : "Add" }}
      </button>
    </div>

    <!-- Edit Mode -->
    <div v-else>
      <multiselect
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        class="app-select"
        :options="options"
        :multiple="true"
        :preserve-search="true"
        :searchable="true"
        :close-on-select="false"
        :allow-empty="true"
        :show-labels="showLabels"
        :placeholder="placeholder"
        :loading="loading"
        :label="label"
        :track-by="trackBy"
        :disabled="disabled"
      >
        <template v-if="$slots.option" #option="props">
          <slot name="option" v-bind="props" />
        </template>
        <template #noResult>
          <div class="no-result">{{ emptySearchText }}</div>
        </template>
      </multiselect>
      <button
        type="button"
        class="btn btn-sm btn-deep-success mt-2"
        @click="editing = false"
      >
        Done
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "ChipMultiselect",
  components: {
    Multiselect,
  },
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "name",
    },
    trackBy: {
      type: String,
      default: "id",
    },
    placeholder: {
      type: String,
      default: "Select...",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: "No items selected",
    },
    emptySearchText: {
      type: String,
      default: "No results found",
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editing: false,
    };
  },
};
</script>
